// src/pages/reports/GeneratedReports.js
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { dateFormate } from "utils/utils";
import GeneratedReportsTab from "./GeneratedReportsTab";
import bookingCount from "assets/images/bookingCount.svg";
import { generatedReportsFetchApi } from "services/GeneratedReportService";

function GeneratedReports() {
  const [value, setValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableData, setTableData] = useState({body: [], header: []});
  const [loader, setLoader] = useState(false);
  const [locValue, setLocValue] = useState(null);
  const [status, setStatus] = useState([]);

  const userProfileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);

  const getFilterData = () => ({
    page: page,
    pageSize: rowsPerPage,
    city: selectedLocation?.id || locValue?.id,
    reportType: value || "COUPON",
    status: status
  });

  useEffect(() => {
    if (userProfileData?.Company?.ServiceCity?.id) {
      setLocValue({
        id: userProfileData?.Company?.ServiceCity?.id,
        name: userProfileData?.Company?.ServiceCity?.name,
      });
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  const fetchData = async (filters) => {
    setLoader(true);
    try {
      const res = await generatedReportsFetchApi(filters);
      if (res.success) {
        setTableData(res.data || {body: [], header: []});
      } else {
        setTableData({body: [], header: []});
      }
    } catch (error) {
      setTableData({body: [], header: []});
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    fetchData({ ...getFilterData(), reportType: newValue });
  };

  useEffect(() => {
    fetchData(getFilterData());
  }, [selectedLocation?.id, locValue?.id, page, rowsPerPage]);

  // Polling useEffect - polls every 30 seconds when there are pending/in-progress items
  useEffect(() => {

    if (tableData?.body.some(item => item.status === 'PENDING' || item.status === 'IN_PROGRESS')) {
      const interval = setInterval(() => {
        fetchData(getFilterData());
      }, 10000);

      return () => clearInterval(interval);
    }
  }, [tableData]);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onInputChange = (data) => {
    setLocValue(data);
  };

  const onFilterChange = (changes) => {
    if (changes.status !== undefined) {
      setStatus(changes.status);
    }

    const finalFilters = { ...getFilterData(), page: 0, ...changes };
    setPage(0);
    fetchData(finalFilters);
  };

  return (
    <GeneratedReportsTab
      loader={loader}
      handleChange={handleChange}
      value={value}
      rideTrackData={tableData}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      rowsPerPage={rowsPerPage}
      onInputChange={onInputChange}
      countSrc={bookingCount}
      title="Generated Reports"
      locValue={locValue}
      onFilterChange={onFilterChange}
      defaultStatus={status}
    />
  );
}

export default GeneratedReports;
